package org.zest.insan_360_website.model

import kotlinx.serialization.Serializable

@Serializable
enum class Attribute {
    Dominance,
    Influence,
    Steadiness,
    Compliance,
    Dummy
}

@Serializable
enum class GraphType { More, Less, Difference }